import { DayforceWindowType } from '../state-adapter/session';
import { Nullable } from './type-utils';

const CSRF_HEADER_TOKEN = 'X-CSRF-TOKEN';

/**
 * Retrieves the CSRF token from the app settings data, supplied on a new user session.
 */
function getCsrfToken(): Nullable<string> {
    let requestToken: Nullable<string> = null;

    // First, we'll check for the token in app settings data generated on startup
    const dayforceInstance: DayforceWindowType | undefined = window['Dayforce'];

    if (dayforceInstance) {
        requestToken = dayforceInstance?.AppSettingsData?.csrfRequestToken;
        if (requestToken) {
            // We have a token generated on startup, so we'll default to using that for all downstream calls
            return requestToken;
        }
    }

    console.warn('No token was associated to the Dayforce instance attached to the current window');

    return requestToken;
}

export const CsrfUtil = {
    CSRF_HEADER_TOKEN,
    getCsrfToken
}